import React from "react";
import { Link } from "gatsby";
import picktimeLogo from "../img/picktime-book-online.png";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
    };
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active",
            })
          : this.setState({
              navBarActiveClass: "",
            });
      }
    );
  };

  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" role="button" title="Logo">
              <strong>Sexualidades Libres</strong>
            </Link>
            <div
              role="button"
              tabIndex={0}
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onKeyDown={() => this.toggleHamburger()}
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <Link className="navbar-item" to="/about">
                Formación
              </Link>
              <Link className="navbar-item" to="/blog">
                Blog
              </Link>
              <Link className="navbar-item" to="/contact">
                Contacto
              </Link>
              <Link className="navbar-item" to="/faq">
                Preguntas Frecuentes
              </Link>
              <Link className="navbar-item" to="/info">
                Datos Útiles
              </Link>
              <Link className="navbar-item" to="/talleres">
                Talleres y Capacitaciones
              </Link>
              <a
                className="navbar-item"
                href="https://www.picktime.com/DraBarbaraGarcia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  border="none"
                  src={picktimeLogo}
                  alt="Reseva un turno con Dra. B&aacute;rbara Garc&iacute;a"
                />
              </a>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
